import { takeEvery, call, select } from 'redux-saga/effects';
import service from '../../services';

function* globalTrigger(action) {
    const { token } = yield select(state => state.API);
    const { triggerId } = action;

    try {
        yield call(() => service.globalTrigger(token, triggerId))
    } catch (e) {

    }
}

export default function* () {
    yield takeEvery('globalTrigger', globalTrigger)
}